var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 17.3332V11.9998C29.3333 5.33317 26.6666 2.6665 20 2.6665H12C5.33329 2.6665 2.66663 5.33317 2.66663 11.9998V19.9998C2.66663 26.6665 5.33329 29.3332 12 29.3332H17.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77332 19.3202L12.9467 15.2002C13.4 14.6135 14.24 14.5069 14.8267 14.9602L17.2667 16.8802C17.8533 17.3335 18.6933 17.2269 19.1466 16.6535L22.2267 12.6802",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9733 21.0934L26.3466 21.8534C26.5333 22.2267 26.9999 22.5734 27.4133 22.6534L27.92 22.7334C29.44 22.9867 29.8 24.1067 28.7066 25.2134L28.2399 25.6801C27.9333 26.0001 27.76 26.6134 27.8533 27.0401L27.92 27.3201C28.3333 29.1601 27.36 29.8667 25.76 28.9067L25.4133 28.7067C24.9999 28.4667 24.3333 28.4667 23.92 28.7067L23.5733 28.9067C21.9599 29.8801 20.9866 29.1601 21.4133 27.3201L21.4799 27.0401C21.5733 26.6134 21.4 26.0001 21.0933 25.6801L20.6266 25.2134C19.5333 24.1067 19.8933 22.9867 21.4133 22.7334L21.92 22.6534C22.32 22.5867 22.7999 22.2267 22.9866 21.8534L23.3599 21.0934C24.0799 19.6401 25.2533 19.6401 25.9733 21.0934Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteChart);
export default __webpack_public_path__ + "static/media/favorite-chart.56b2e0c3989ce354549eb0293050d48c.svg";
export { ForwardRef as ReactComponent };